var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"budget-modal-card mt-2",style:(_vm.isScrolled ? {
			position: 'sticky',
			top: _vm.budgetHeaderHeight + 'px',
			left: '0',
			right: '0',
			zIndex: 9
		} : {})},[_c('v-card-text',{staticClass:"py-4"},[_c('vue-file-toolbar-menu',{staticClass:"bar",attrs:{"content":_vm.menu}})],1)],1),_c('v-card',{staticClass:"budget-modal-card"},[_c('v-card-text',{staticClass:"py-4"},[_c('vue-document-editor',{ref:"budgetTextEditor",attrs:{"id":"budget-editor","content":_vm.budgetTextContent,"zoom":_vm.zoom,"page_format_mm":_vm.page_format_mm,"page_margins":_vm.page_margins,"overlay":_vm.overlay,"display":_vm.display},on:{"update:content":function($event){_vm.budgetTextContent=$event}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }